/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import DrawerMenu from '@salesforce/retail-react-app/app/theme/components/project/drawer-menu'

DrawerMenu.baseStyle = {
    ...DrawerMenu.baseStyle,
    drawer: {
        placement: 'left',
        size: '100%'
    },
    body: {
        padding: 0,
        overflowX: 'hidden',
        overflowY: 'auto'
    },
    brandsWrapper: {
        display: 'flex',
        width: '100%'
    },
    skeleton: {
        width: '200px',
        height: '1000px',
        marginRight: 'auto'
    },
    kendraScottLogo: {
        viewBox: 'none',
        width: '124px',
        height: '21px',
        marginBottom: '0.1rem'
    },
    yellowRoseLogo: {
        viewBox: 'none',
        width: '80px',
        height: '12px',
        marginBottom: '0.3rem'
    },
    closeIcon: {
        top: '1rem'
    },
    iconButtons: {
        borderRadius: '0',
        width: '50%',
        variant: 'unstyled'
    },
    categoriesWrapper: {
        padding: '0.8rem 1rem'
    }
}

export default DrawerMenu
